import type { FaireProductEntity } from "../../entity_types/product";

export const p_6dzhzg89e9: FaireProductEntity = {
  token: "p_6dzhzg89e9",
  type: "product",
  name: "STEVIE Mismatch Gemstone Dangle Earrings",
  brandToken: "b_cm6t2hxqzv",
  brandName: "By Orly",
  imageUrl:
    "https://cdn.faire.com/fastly/1fad125ef7a6177f3ae225e042251979e82ee7d72b41125807fb818dacd8d42c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8a08cee46b0d7e2792d27900f9eabfba559033f97aec05325f34d1dc97c70d6a.jpeg",
    "https://cdn.faire.com/fastly/3224c85263c70ae22a789a78b39d041497d1b7bf1b68c9343913e37ce4a35db0.jpeg",
  ],
  priceDollars: 37.5,
  description:
    "\nMismatch gemstone drop earrings. Featuring a smooth metal teardrop earring post, each pair offers a different stone that compliments it's partner. \n\n * Lapis, Dalmatian Jasper, Yellow Topaz, Carnelian, Blue Agate \n * 11x7mm Metal Earring Post \n * 8mm and 12mm Beads \n * Silicone Push Back Closure ",
  tags: [],
  msrpDollars: 75,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:35.345Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
